"use client";

import { c as _c } from "react/compiler-runtime";
import { Check, X } from "lucide-react";
import type { CampaignPageSection } from "@growwithai/shared";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type ChecklistSectionData = Extract<CampaignPageSection, {
  type: "checklist";
}>;

/** Kolom "cocok untuk" vs "bukan untuk" — pola pembanding umum di sales page. */
export default function ChecklistSection(t0) {
  const $ = _c(24);
  const {
    section
  } = t0;
  let t1;
  if ($[0] !== section.yes_items) {
    t1 = section.yes_items ?? [];
    $[0] = section.yes_items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const yesItems = t1;
  let t2;
  if ($[2] !== section.no_items) {
    t2 = section.no_items ?? [];
    $[2] = section.no_items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const noItems = t2;
  if (yesItems.length === 0 && noItems.length === 0) {
    return null;
  }
  let t3;
  if ($[4] !== section.custom_style) {
    t3 = sectionBgStyle(section.custom_style);
    $[4] = section.custom_style;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== section.custom_style || $[7] !== section.heading) {
    t4 = section.heading && <h2 className="mb-8 text-center text-2xl font-bold tracking-tight text-warm-black md:text-3xl" style={sectionHeadingStyle(section.custom_style)}>{section.heading}</h2>;
    $[6] = section.custom_style;
    $[7] = section.heading;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== section.yes_title || $[10] !== yesItems) {
    t5 = yesItems.length > 0 && <div className="rounded-2xl border border-emerald-200 bg-emerald-50/50 p-5"><p className="mb-3 text-sm font-bold text-emerald-800">{section.yes_title}</p><ul className="space-y-2.5">{yesItems.map(_temp)}</ul></div>;
    $[9] = section.yes_title;
    $[10] = yesItems;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== noItems || $[13] !== section.no_title) {
    t6 = noItems.length > 0 && <div className="rounded-2xl border border-rose-200 bg-rose-50/50 p-5"><p className="mb-3 text-sm font-bold text-rose-800">{section.no_title}</p><ul className="space-y-2.5">{noItems.map(_temp2)}</ul></div>;
    $[12] = noItems;
    $[13] = section.no_title;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className="grid gap-5 sm:grid-cols-2">{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t4 || $[19] !== t7) {
    t8 = <div className="mx-auto max-w-3xl px-5">{t4}{t7}</div>;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t3 || $[22] !== t8) {
    t9 = <section className="bg-white py-10 md:py-14" style={t3}>{t8}</section>;
    $[21] = t3;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}
function _temp2(item_0, i_0) {
  return <li key={i_0} className="flex items-start gap-2 text-[14px] text-rose-900"><X className="mt-0.5 h-4 w-4 shrink-0 text-rose-500" aria-hidden={true} /><span>{item_0}</span></li>;
}
function _temp(item, i) {
  return <li key={i} className="flex items-start gap-2 text-[14px] text-emerald-900"><Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" aria-hidden={true} /><span>{item}</span></li>;
}